// React
import React from 'react';
import {
  Col,
  Row,
  Form,
  Modal,
  Input,
  Label,
  Button,
  ModalBody,
} from 'reactstrap';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Utils
import { useLoading } from '../../../../../../../hook/useLoading';

export const ModalDepartment = ({
  api,
  toggle,
  isOpen,
  idOrganization,
  validationDepartment,
}) => {
  const { loadingWithTime } = useLoading();

  // Functions
  const handleSubmit = (values) => {
    api
      .create('/register/unit', values)
      .then((response) => {
        getDepartmentsByRead(response.id);
      })
      .catch((error) => {
        return error;
      });
  };

  const resetNameInput = () => {
    if (validation.values.nameInput) {
      validation.handleChange({
        target: {
          name: 'nameInput',
          value: '',
        },
      });
    }
  };

  // GET calls
  const getDepartmentsByRead = async (id) => {
    const response = await api.get(`/register/unit/${id}`);

    if (response) {
      validationDepartment.handleChange({
        target: {
          name: 'department',
          value: {
            value: response.id,
            label: response.name,
          },
        },
      });
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: '',
      organization: idOrganization,
    },
    validationSchema: Yup.object({
      organization: Yup.string(),
      nameInput: Yup.string().required('Nome é obrigatório'),
    }),
    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput,
        organization_id: values.organization,
      };

      loadingWithTime(1000);
      handleSubmit(valuesToSubmit);

      toggle();
      validation.resetForm();
    },
  });

  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      backdrop="static"
      modalClassName="fadeInLeft"
    >
      <Col className="modal-content border-0">
        <Col className="modal-header p-3 bg-soft-info">Nova Lotação</Col>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit(e);
          }}
        >
          <ModalBody className="modal-body mb-3">
            <Row className="g-3">
              <Col md={12}>
                <Label>Adicionar nova lotação</Label>
                <Input
                  id="nameInput"
                  className="form-control"
                  value={validation.values.nameInput}
                  onChange={(e) => {
                    validation.handleChange(e);
                  }}
                  invalid={
                    !!(
                      validation.touched.nameInput &&
                      validation.errors.nameInput
                    )
                  }
                />
              </Col>
            </Row>
          </ModalBody>
          <Row className="modal-footer">
            <Col className="hstack gap-2 justify-content-end">
              <button
                type="button"
                onClick={() => {
                  resetNameInput();
                  toggle();
                }}
                className="btn btn-link"
              >
                Cancelar
              </button>
              <Button id="add-btn" type="submit" className="btn btn-secondary">
                Salvar
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Modal>
  );
};
